import { ComponentIds, Entity } from '@inter-ikea-core/core';
import {
  InteriorComponent,
  ProductDesign,
  ProductInfoComponent
} from '@inter-ikea-storageone/range';
import { useCore } from 'contexts/core';
import { getProductEntities } from 'ducks/core';
import { useAppDispatch } from 'ducks/hooks';
import { showInfoMessage } from 'ducks/layout';
import { getMarketProducts } from 'ducks/products';
import { changeInteriorColor } from 'rangeConfig/shared/utils/colorUtils/changeInteriorColor';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ChangeColor from './ChangeColor';

const ChangeInteriorColor = () => {
  const coreApi = useCore();
  const dispatch = useAppDispatch();
  const products = useSelector(getMarketProducts);
  const productEntities = useSelector(getProductEntities);
  const [interiorEntities, setInteriorEntities] = useState<Entity[]>([]);

  const frames = coreApi.entities
    .getAll()
    .filter(e => e.hasComponent(ComponentIds.FRAME_COMPONENT_ID));
  const defaultColor =
    frames.length > 0
      ? (frames[0].getComponent<ProductInfoComponent>(ProductInfoComponent.id)
          ?.design as ProductDesign)
      : ProductDesign.WHITE;

  useEffect(() => {
    setInteriorEntities(
      coreApi.entities.getAll().filter(e => e.hasComponent(InteriorComponent.id))
    );
  }, [coreApi, productEntities]);

  const onChangeColor = (design: ProductDesign) => {
    const notReplaceableInteriorFound = changeInteriorColor(
      coreApi,
      interiorEntities,
      design,
      products
    );

    if (notReplaceableInteriorFound) {
      dispatch(showInfoMessage({ message: 'storageone.changeColorInteriorsUnavailableMessage' }));
    }
  };

  return (
    <ChangeColor
      entities={interiorEntities}
      onChangeColor={onChangeColor}
      defaultColor={defaultColor}
    />
  );
};

export default ChangeInteriorColor;
